module.exports = __webpack_public_path__ + "img/time_line_img06.dd23e747.png";